// extracted by mini-css-extract-plugin
module.exports = {"searchAndCreateContainer":"UserAttributesTemplate-tab_searchAndCreateContainer_2xhpG","searchInput":"UserAttributesTemplate-tab_searchInput_1zw9i"};